module.exports = __webpack_public_path__ + "media/images/balance-product-arrowdown2-2400044e132ec3745b3c76f31cbc266e.png";